/**
 * Tooltip — доступный тултип (hover + клавиатурный фокус + tap на мобильном).
 * CSS-only появление с задержкой ~300мс. Многострочный текст (whitespace-pre-line).
 */
import type { ReactNode } from "react";

export function Tooltip({ text, children, className = "" }: { text: string; children: ReactNode; className?: string }) {
  return (
    <span
      className={`relative inline-flex items-center group/tt focus:outline-none ${className}`}
      tabIndex={0}
      aria-label={text}
    >
      {children}
      <span
        role="tooltip"
        className="pointer-events-none absolute z-50 left-1/2 bottom-full mb-1.5 -translate-x-1/2
                   w-64 max-w-[16rem] rounded-md bg-neutral-900 px-2.5 py-2 text-[11px] leading-snug
                   text-white shadow-lg whitespace-pre-line text-left
                   opacity-0 invisible transition-opacity duration-150 delay-300
                   group-hover/tt:opacity-100 group-hover/tt:visible
                   group-focus/tt:opacity-100 group-focus/tt:visible"
      >
        {text}
      </span>
    </span>
  );
}

/** Tip — тултип в стиле прототипа Aikido (.tip/.pop). text — многострочный (что/как/почему). */
export function Tip({ text, children }: { text: string; children: ReactNode }) {
  return (
    <span className="tip" tabIndex={0}>
      {children}
      <span className="pop" style={{ whiteSpace: "pre-line" }}>{text}</span>
    </span>
  );
}

/** Маленький значок «?» с тултипом — для заголовков колонок и т.п. */
export function InfoDot({ text }: { text: string }) {
  return (
    <Tooltip text={text}>
      <span className="ml-0.5 inline-flex h-3.5 w-3.5 items-center justify-center rounded-full
                       bg-neutral-200 text-[9px] font-bold text-neutral-500 cursor-help select-none">?</span>
    </Tooltip>
  );
}
